// Scene units & viewport mapping. Owned by docs/gameplay-config.md#scene.

export const SCENE_WIDTH = 1080;
export const SCENE_HEIGHT = 1920;
export const FIT_MODE: "contain" = "contain";
